import { useMsal } from "@azure/msal-react"
import { LogOut } from "lucide-react"

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "./ui/dropdown-menu.tsx"
import { SidebarMenu, SidebarMenuButton, SidebarMenuItem } from "./ui/sidebar.tsx"

import type { EndSessionRequest } from "@azure/msal-browser"

export default function UserInfo() {
  const { accounts, instance } = useMsal()
  const account = accounts[0]

  const handleLogout = () => {
    const req: EndSessionRequest = {
      account,
    }
    instance.logoutRedirect(req)
  }

  return (
    <SidebarMenu>
      <SidebarMenuItem className="py-4">
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <SidebarMenuButton className="py-6 gap-3">
              <div className="w-full">
                <div>{account.name}</div>
                <div className="text-muted-foreground text-nowrap max-w-full text-ellipsis overflow-hidden text-xs">
                  {account.username}
                </div>
              </div>
            </SidebarMenuButton>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" sideOffset={4}>
            <DropdownMenuGroup>
              <DropdownMenuItem onClick={handleLogout}>
                <LogOut />
                Logout
              </DropdownMenuItem>
            </DropdownMenuGroup>
          </DropdownMenuContent>
        </DropdownMenu>
      </SidebarMenuItem>
    </SidebarMenu>
  )
}
